/**
 * Giorno da preselezionare nel calendario di un servizio, letto dal parametro
 * ?date= del link (lo costruisce il chatbot). Vale solo se è fra le date che il
 * calendario offre: un link vecchio o scritto a mano non seleziona niente.
 *
 * @param {string|undefined} search         location.search della pagina
 * @param {string[]|null}    availableDates date YYYY-MM-DD offerte dal calendario
 * @returns {string|null}
 */
export function preselectedDate(search, availableDates) {
  const date = new URLSearchParams(search || '').get('date');

  if (!date || !Array.isArray(availableDates)) return null;

  return availableDates.includes(date) ? date : null;
}

/**
 * Percorso della pagina di prenotazione del servizio, con il giorno selezionato
 * se c'è. Serve al redirect del login: chi arriva dal chatbot senza essere
 * loggato ritrova, dopo il login, il giorno che aveva scelto.
 *
 * @param {number|string} serviceId
 * @param {string|null}   date      YYYY-MM-DD, oppure vuoto
 * @returns {string}
 */
export function reservationPath(serviceId, date) {
  return `/app/reservations/${serviceId}${date ? `?date=${date}` : ''}`;
}

/**
 * Percorso della pagina del dispositivo a noleggio, con il giorno di ritiro
 * selezionato se c'è: serve al redirect del login, come reservationPath per i
 * servizi.
 *
 * @param {number|string} deviceId
 * @param {string|null}   date     YYYY-MM-DD, oppure vuoto
 * @returns {string}
 */
export function rentalPath(deviceId, date) {
  return `/app/rentals/${deviceId}${date ? `?date=${date}` : ''}`;
}
